import api from 'api/axiosInstance';

export interface CardProduct {
  id: string;
  cardDesignUrl: string;
  label: 'aldo' | 'standard';
}

export const getCardsProductsList = async (): Promise<CardProduct[]> =>
  api.get('/v2/accountable-banking/cards/products');
